import { FormControlLabel, Stack, Switch, Typography, useTheme } from '@mui/material';

// Components
import { StyledWhiteBox } from 'src/features/PortDetail/config';
import { renderNumberOrDefault, renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import Table from 'src/components/Table';
import { useState } from 'react';

// Utilities
import { ITopPartner, ITopCountryPartner } from 'src/utils/typings/response';

interface IProps {
  listTopPartner: Array<ITopPartner>;
  listTopCountryPartner: Array<ITopCountryPartner>;
  period: {
    port: string;
    country: string;
  };
}

const ExportDestinationTable = ({ listTopPartner, listTopCountryPartner, period }: IProps) => {
  const theme = useTheme();
  const [isByCountry, setIsByCountry] = useState<boolean>(false);

  const configColumn: ConfigCell<ITopPartner>[] = [
    {
      id: 'name',
      disablePadding: true,
      disableSort: true,
      label: 'Name',
      cell: (row: ITopPartner) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderTextOrDefault(row?.name)}
          </Typography>
        );
      },
    },
    {
      id: 'locode',
      disablePadding: true,
      disableSort: true,
      label: 'Locode',
      cell: (row: ITopPartner) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderTextOrDefault(row?.locode)}
          </Typography>
        );
      },
    },
    {
      id: 'volume',
      disablePadding: true,
      disableSort: true,
      label: 'Volume, TEU',
      cell: (row: ITopPartner) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderNumberOrDefault(row?.volume)}
          </Typography>
        );
      },
    },
  ];

  const configColumnCountry: ConfigCell<ITopCountryPartner>[] = [
    {
      id: 'country',
      disablePadding: true,
      disableSort: true,
      label: 'Destination',
      cell: (row: ITopCountryPartner) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderTextOrDefault(row?.country)}
          </Typography>
        );
      },
    },
    {
      id: 'volume',
      disablePadding: true,
      disableSort: true,
      label: 'Volume, TEU',
      cell: (row: ITopCountryPartner) => {
        return (
          <Typography variant="body2" color="text.secondary">
            {renderNumberOrDefault(row?.volume)}
          </Typography>
        );
      },
    },
  ];

  return (
    <StyledWhiteBox display="flex" flexDirection="column" gap={2} flex={1}>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h5" align="left">
          Exports by destination
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={isByCountry}
              onChange={(e) => {
                setIsByCountry(e.target.checked);
              }}
              size="medium"
              color="primary"
              id="by_port_country_import"
              name="by_port_country_import"
            />
          }
          sx={{
            '& .MuiFormControlLabel-label': {
              marginLeft: theme.spacing(1),
            },
          }}
          label={isByCountry ? 'By Country' : 'By Port'}
        />
      </Stack>
      <Typography variant="body1" color="text.secondary" align="left">
        {isByCountry ? period.country : period.port}
      </Typography>
      {isByCountry ? (
        <Table
          data={listTopCountryPartner}
          configColumn={configColumnCountry}
          dataKey="volume"
          isPagination={false}
          maxRow={5}
          // totalRecords={getArrayDefault(listTerminal).length}
          totalRecords={listTopCountryPartner.length}
        />
      ) : (
        <Table
          data={listTopPartner}
          configColumn={configColumn}
          dataKey="volume"
          isPagination={false}
          maxRow={5}
          totalRecords={listTopPartner.length}
        />
      )}
    </StyledWhiteBox>
  );
};

export default ExportDestinationTable;
